export const CalendarIcon = ({ color = 'currentColor', ...props }: JSX.IntrinsicElements['svg']) => {
  return (
    <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <rect x='0.75' y='2.25' width='16.5' height='15' rx='3.75' stroke={color} strokeWidth='1.5' />
      <rect x='4.5' width='1.5' height='4.5' rx='0.75' fill={color} />
      <rect x='12' width='1.5' height='4.5' rx='0.75' fill={color} />
      <rect x='8.25' width='1.5' height='4.5' rx='0.75' fill={color} />
      <rect opacity='0.75' x='3' y='9' width='3' height='3' rx='1.5' fill={color} />
      <rect opacity='0.25' x='7.5' y='9' width='3' height='3' rx='1.5' fill={color} />
      <rect opacity='0.25' x='12' y='9' width='3' height='3' rx='1.5' fill={color} />
      <path d='M0.75 6.75H17.25' stroke={color} strokeWidth='1.5' />
    </svg>
  );
};
